import { clearParameters, createImageStylePath } from './imageHelpers';
import isDamImage from './isDamImage';

const damImageSwatchFormatter = (swatchImg, options = {}) => {
  const damImage = isDamImage(swatchImg);
  if (damImage) {
    const imageStyle = options.damImageStyle || '46x46';
    swatchImg = createImageStylePath(
      imageStyle,
      clearParameters(swatchImg),
      true,
    );
    return swatchImg;
  }
  return swatchImg;
};
export default damImageSwatchFormatter;
